
import Axios from 'axios'
export const getCourseList = async ()=>{
    let res = await Axios.get('/my_courses',{params:{pageSize:999}})
    return res.data
}